import React from 'react'

import { setDebouncedSearchQuery, setSearchQuery } from 'slices/filters'

import { Box, InputText } from '@driftt/dds'

import { useDebouncedCallback } from 'hooks/useDebouncedCallback'
import { useAppDispatch, useAppSelector } from 'hooks/useRedux'
import { segmentTrack, TrackType } from 'utils/tracking'

const SearchBar = () => {
  const dispatch = useAppDispatch()
  const { searchQuery, debouncedSearchQuery } = useAppSelector(state => state.filters)
  const debouncedCallback = useDebouncedCallback((query: string) => {
    dispatch(setSearchQuery(query))
    segmentTrack(TrackType.DASHBOARD_SEARCH)
  }, 300)

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setDebouncedSearchQuery(e.target.value))
    debouncedCallback(e.target.value)
  }

  return (
    <Box
      css={{
        background: '$white',
        alignSelf: 'flex-start'
      }}>
      <InputText
        hideLabel={true}
        value={debouncedSearchQuery}
        data-testid="dashboard-search-bar"
        placeholder={searchQuery || 'Search accounts...'}
        label="Search accounts"
        labelOptional={true}
        onChange={handleSearch}
      />
    </Box>
  )
}

export default SearchBar
